/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-05-11",
    versionChannel: "nightly",
    buildDate: "2025-05-11T00:07:18.441Z",
    commitHash: "54bbb95ae4b71d960eb87ece469706ebd1b3203c",
};
